// src/layouts/ListIcons/ListIcons.js

import React from "react"
import styled from 'styled-components'

import iconsBook from '../../images/icons_book.png'
import iconsHorseshoe from '../../images/icons_horseshoes.png'
import iconsMapMarker from '../../images/icons_map-marker.png'
import iconsMeetingSpace from '../../images/icons_meeting-spaces.png'
import iconsRestroom from '../../images/icons_restrooms.png'
import iconsWashers from '../../images/icons_washers.png'
import iconsZoom from '../../images/icons_zoom.png'

const ListIcons = ({ zoomList, meetingList, restroomList, bookList, washersList, horseshoeList, rideshareList }) => {

  return (
    <BlockContent 
      itemScope
      itemType="http://schema.org/Review"
      data-sal="slide-up"
        data-sal-duration="1000"
        data-sal-delay="300"
        data-sal-easing="ease"
    >
      <ListWithIcons>
          <img src={iconsZoom} class="icons" alt="Book Icon" width="45" />
          <p>{zoomList}</p>
      </ListWithIcons>
      <ListWithIcons>
          <img src={iconsMeetingSpace} class="icons" alt="Book Icon" width="45" />
          <p>{meetingList}</p>
      </ListWithIcons>
      <ListWithIcons>
          <img src={iconsRestroom} class="icons" alt="Book Icon" width="45" />
          <p>{restroomList}</p>
      </ListWithIcons>
      <ListWithIcons>
          <img src={iconsBook} class="icons" alt="Book Icon" width="45" />
          <p>{bookList}</p>
      </ListWithIcons>
      <ListWithIcons>
          <img src={iconsWashers} class="icons" alt="Book Icon" width="45" />
          <p>{washersList}</p>
      </ListWithIcons>
      <ListWithIcons>
          <img src={iconsHorseshoe} class="icons" alt="Book Icon" width="45" />
          <p>{horseshoeList}</p>
      </ListWithIcons>
      <ListWithIcons>
          <img src={iconsMapMarker} class="icons" alt="Book Icon" width="45" />
          <p>{rideshareList}</p>
      </ListWithIcons>
    </BlockContent>
  )
}

const BlockContent = styled.section`
  position: relative;
  max-width: 1360px;
  width: 100%;
  margin: 70px auto;
  padding: 0 20px;
  padding-top: 20px;
  @media(max-width:1000px) {
    max-width: 700px;
  }
  @media(max-width: 767px) {
    max-width: 500px;
    margin: 50px auto;
    padding-top: 10px;
    overflow: hidden;
  }
`

const ListWithIcons = styled.div`
  max-width: 980px;
  width: 100%;
  margin: 0px auto;
  position: relative;
  padding: 0px 20px;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  p {
    font-family: "Work Sans";
    font-size: 18px;
    font-weight: 400;
    line-height: 38px;
    color: #777c7c;
    margin-bottom: 0;
    padding-left: 40px;
  }
  @media(max-width:1000px) {
    max-width: 700px;
  }
  @media(max-width: 767px) {
    max-width: 500px;
    padding: 0;
    margin: 20px auto;
    p {
      font-size: 16px;
    }
    img {
      width: 35px;
    }
  }
`

export default ListIcons